
import { Jumbotron } from "sections";
import parse from "html-react-parser";
import "../personal.css";
import { useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "components/buttons";
import { Col, Container, Row } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";
import _ from "lodash";
import axios from "axios";
import moment from "moment";

function ImportantNoticeDetail() {
  const { slug } = useParams();
  const [notice, setNotice] = useState();
  const navigate = useNavigate();
  const [importantNoticeListLegacy, setImportantNoticeListLegacy] = useState([]);
  const [importantNoticeListCms, setImportantNoticeListCms] = useState([]);

  useEffect(() => {
    const fetchImportantNoticeFromSpreadSheet = async () => {
      try {
        const response = await axios.get(
          "https://www.alrajhibank.com.my/assets/contents/important-notice.json"
        );
        const jsonResponse = response.data;
        setImportantNoticeListLegacy(jsonResponse);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    const fetchImportantNoticeFromCMS = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_CMS_BASE_URL}/important-notices?populate=*&sort=createdAt:desc&pagination[limit]=100`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
            },
          }
        );

        const formatToLegacy = response.data.data.map(notice => {
          return {
            title: notice.header,
            date: moment(notice.date).format("DD MMM YYYY"),
            slug: notice.slug,
            content: notice.contentTemplate,
          }
        });
        setImportantNoticeListCms(formatToLegacy);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchImportantNoticeFromSpreadSheet();
    fetchImportantNoticeFromCMS();
  }, []);

  useEffect(() => {
    const findNotice = [...importantNoticeListCms, ...importantNoticeListLegacy].find((n) => n.slug === slug);
    setNotice(findNotice);
  }, [importantNoticeListLegacy, importantNoticeListCms, slug]);

  return (
    <>
      <section className="section jumbotron">
        <Jumbotron
          title={`<span className="jumbotron-subtitle-2">Important</span> Notices`}
        />
      </section>
      <section className="important-notice-details">
        {notice && (
          <Container>
            <Row>
              <Col>
                <div className="border-bottom pb-2">
                  <h2>{notice?.title}</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="py-2">
                  <div className="d-flex flex-row-reverse">{notice?.date}</div>
                  <div className="py-4">
                    <div>{parse(notice?.content)}</div>
                  </div>
                  <div className="text-center my-4">
                    <PrimaryButton
                      text="Back to Homepage"
                      onClick={() => navigate("/")}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        )}
      </section>
    </>
  );
}

export default ImportantNoticeDetail;
